import type { ProductAllFeaturesContent, ProductFeatureCategory } from "~/data/products/types";

// Keys carry the `fleet:` namespace prefix because the shared all-features components
// translate through the "products" namespace.
function featureCategory(key: string, cardCount: number): ProductFeatureCategory {
  return {
    label: `fleet:all_features.categories.${key}.label`,
    cards: Array.from({ length: cardCount }, (_, i) => ({
      title: `fleet:all_features.categories.${key}.cards.${i}.title`,
      description: `fleet:all_features.categories.${key}.cards.${i}.description`,
    })),
  };
}

export const FLEET_ALL_FEATURES: Omit<ProductAllFeaturesContent, "banner"> = {
  metaTitle: "fleet:all_features.title",
  metaDescription: "fleet:all_features.description",
  headline: "fleet:all_features.headline",
  description: "fleet:all_features.intro",
  featureDetailsHeading: "fleet:all_features.feature_details",
  expandAllLabel: "fleet:all_features.expand_all",
  collapseAllLabel: "fleet:all_features.collapse_all",
  categories: [
    { slug: "gps-routes", icon: "gps", category: featureCategory("gps_routes", 6) },
    { slug: "driving-insights", icon: "insights", category: featureCategory("driving_insights", 6) },
    { slug: "safety-security", icon: "safety", category: featureCategory("safety_security", 6) },
    { slug: "care-diagnostics", icon: "diagnostics", category: featureCategory("care_diagnostics", 6) },
    { slug: "users-access", icon: "access", category: featureCategory("users_access", 3) },
  ],
};
